import { useParams } from "react-router-dom";
import { useGetMessagesQuery } from "../../../features/messages/messagesApi";
import Error from "../../ui/Error";
import Blank from "../Blank";
import ChatHead from "./ChatHead";
import Messages from "./Messages";
import Options from "./Options";

export default function ChatBody() {
  const { id } = useParams();
  const {
    data,
    isError,
    isLoading,
    error,
    isSuccess,
  } = useGetMessagesQuery(id) || {};

  const { data: messages, totalMessages } = data || {};

  let content = null;

  if (isLoading) {
    content = <div>Loading...</div>;
  } else if (isError) {
    content = <Error message={error?.error} />;
  } else if (!isLoading && !isError && messages?.length === 0) {
    content = <Blank />;
  } else if (isSuccess && messages?.length > 0) {
    content = (
      <>
        <ChatHead message={messages[0]} />
        <Messages messages={messages} totalCount={totalMessages} conversationId={id} />
        <Options info={messages[0]} />
      </>
    );
  }

  return (
    <div className="w-full lg:col-span-2 lg:block">
      <div className="w-full grid conversation-row-grid">{content}</div>
    </div>
  );
}
